export enum ErrorStatus {
  NOT_MODIFIED = 304,
  UNAUTHORIZED = 401,
  PAYMENT_REQUIRED = 402,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  NOT_ACCEPTABLE = 406,
  UPDATE_REQUIRED = 426,
  INTERNAL_SERVER_ERROR = 500,
  BAD_GATEWAY = 502,
  AUTH_USER_ERROR = 600,
  RE_AUTHORIZATION = 601,
  NO_AVAILABLE_OPERATORS = 602,
  DELETED_COOKIES = 603,
}
